import { Routes, Route } from 'react-router-dom';
import { SafetyDashboardPage } from './safety-dashboard-page';
import { JSAsPage } from './jsas/jsas-page';
import { CreateJSAPage } from './jsas/create-jsa-page';
import { JSADetailPage } from './jsas/jsa-detail-page';
import { WorkPlansPage } from './work-plans/work-plans-page';
import { CreateWorkPlanPage } from './work-plans/create-work-plan-page';
import { WorkPlanDetailPage } from './work-plans/work-plan-detail-page';
import { RescuePlansPage } from './rescue-plans/rescue-plans-page';
import { CreateRescuePlanPage } from './rescue-plans/create-rescue-plan-page';
import { RescuePlanDetailPage } from './rescue-plans/rescue-plan-detail-page';
import { ToolboxTalksPage } from './toolbox-talks/toolbox-talks-page';
import { CreateToolboxTalkPage } from './toolbox-talks/create-toolbox-talk-page';
import { ToolboxTalkDetailPage } from './toolbox-talks/toolbox-talk-detail-page';
import { ToolboxAnalyticsPage } from './toolbox-analytics-page';
import { NearMissesPage } from './near-misses/near-misses-page';
import { CreateNearMissPage } from './near-misses/create-near-miss-page';
import { NearMissDetailPage } from './near-misses/near-miss-detail-page';
import { TemplatesPage } from './templates/templates-page';
import { CreateTemplatePage } from './templates/create-template-page';
import { IncidentsPage } from './incidents/incidents-page';
import { CreateIncidentPage } from './incidents/create-incident-page';
import { IncidentDetailPage } from './incidents/incident-detail-page';
import { RescueDrillsPage } from './rescue-drills/rescue-drills-page';
import { CreateRescueDrillPage } from './rescue-drills/create-rescue-drill-page';
import { RescueDrillDetailPage } from './rescue-drills/rescue-drill-detail-page';
import { JSAArchivePage } from './jsa-archive/jsa-archive-page';

export function SafetyPage() {
  return (
    <Routes>
      <Route index element={<SafetyDashboardPage />} />
      <Route path="jsas" element={<JSAsPage />} />
      <Route path="jsas/new" element={<CreateJSAPage />} />
      <Route path="jsa-archive" element={<JSAArchivePage />} />
      <Route path="jsas/:id" element={<JSADetailPage />} />
      <Route path="work-plans" element={<WorkPlansPage />} />
      <Route path="work-plans/new" element={<CreateWorkPlanPage />} />
      <Route path="work-plans/:id/edit" element={<CreateWorkPlanPage />} />
      <Route path="work-plans/:id" element={<WorkPlanDetailPage />} />
      <Route path="rescue-plans" element={<RescuePlansPage />} />
      <Route path="rescue-plans/new" element={<CreateRescuePlanPage />} />
      <Route path="rescue-plans/:id/edit" element={<CreateRescuePlanPage />} />
      <Route path="rescue-plans/:id" element={<RescuePlanDetailPage />} />
      <Route path="toolbox-talks" element={<ToolboxTalksPage />} />
      <Route path="toolbox-talks/new" element={<CreateToolboxTalkPage />} />
      <Route path="toolbox-talks/:id" element={<ToolboxTalkDetailPage />} />
      <Route path="toolbox-analytics" element={<ToolboxAnalyticsPage />} />
      <Route path="near-misses" element={<NearMissesPage />} />
      <Route path="near-misses/new" element={<CreateNearMissPage />} />
      <Route path="near-misses/:id" element={<NearMissDetailPage />} />
      <Route path="templates" element={<TemplatesPage />} />
      <Route path="templates/new" element={<CreateTemplatePage />} />
      <Route path="incidents" element={<IncidentsPage />} />
      <Route path="incidents/new" element={<CreateIncidentPage />} />
      <Route path="incidents/:id" element={<IncidentDetailPage />} />
      <Route path="rescue-drills" element={<RescueDrillsPage />} />
      <Route path="rescue-drills/new" element={<CreateRescueDrillPage />} />
      <Route path="rescue-drills/:id" element={<RescueDrillDetailPage />} />
    </Routes>
  );
}
